module.exports = __webpack_public_path__ + "img/ledd_1000.b76c2717.jpg";